/**
 * this is lifted from its npm package source codes
 * @ai-media-lib/notifications
 *
 * but most of the code using ngx-toastr are removed and replaced with ng-material snackbar
 */

import { Inject, Injectable, Injector } from "@angular/core";
import { MatSnackBarRef } from "@angular/material/snack-bar";
import { SnackIconSet } from "src/app/types";
import { SnackBarComponent } from "../ng-material/snack-bar/snack-bar.component";
import { SnackBarService } from "../ng-material/snack-bar/snack-bar.service";

interface IOpenSnackParams {
    message: any,
    permanent: boolean,
    title?: string,
    action?: string,
    snack_type: SnackIconSet,
    className: string
}

@Injectable({
    providedIn: "root",
})
export class NotificationsService {
    snbRef: MatSnackBarRef<SnackBarComponent> | undefined
    injector: Injector;
    constructor(@Inject(Injector) injector: Injector) {
        this.injector = injector;
        this.snbRef = undefined
    }

    get snackBarService() {
        return this.injector.get(SnackBarService)
    }

    private openSnack (data: IOpenSnackParams) {
        const {
            message,
            permanent,
            title,
            action,
            snack_type,
            className
        } = data

        this.snbRef = this.snackBarService.openSnackBar(
            {
                message,
                title,
                action,
                className,
                snack_type,
                permanent,
                hPosition: 'center',
                vPosition: 'bottom',
            }
        );
    }

    error(message: any, permanent = false, title?: string, action?: string) {
        this.openSnack({
            message,
            title,
            action,
            className: `snack-${SnackIconSet.error}`,
            snack_type: SnackIconSet.error,
            permanent
        });
    }

    info(message: any, permanent = false, title?: string, action?: string) {
        this.openSnack({
            message,
            title,
            action,
            className: `snack-${SnackIconSet.info}`,
            snack_type: SnackIconSet.info,
            permanent
        });
    }
    message(message: any, permanent = false, title?: string, action?: string) {
        this.openSnack({
            message,
            title,
            action,
            className: `snack-${SnackIconSet.success}`,
            snack_type: SnackIconSet.success,
            permanent
        });
    }
    clear() {
        this.snbRef?.dismiss()
        this.snbRef = undefined
    }
}
